import { render, staticRenderFns } from "./LiquidarContasAPagar.vue?vue&type=template&id=2d119380&scoped=true"
import script from "./LiquidarContasAPagar.vue?vue&type=script&lang=js"
export * from "./LiquidarContasAPagar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d119380",
  null
  
)

export default component.exports